"use strict";
exports.__esModule = true;
exports.UserMembershipRoleEnum = void 0;
var RoleEnum;
(function (RoleEnum) {
    RoleEnum["User"] = "User";
    RoleEnum["Admin"] = "Admin";
    RoleEnum["Staff"] = "Staff";
    RoleEnum["Superuser"] = "Superuser";
})(RoleEnum || (RoleEnum = {}));
var UserMembershipRoleEnum;
(function (UserMembershipRoleEnum) {
    UserMembershipRoleEnum["Sourcer"] = "SOURCER";
    UserMembershipRoleEnum["FullMember"] = "FULL_MEMBER";
    UserMembershipRoleEnum["Interviewer"] = "INTERVIEWER";
    UserMembershipRoleEnum["Admin"] = "ADMIN";
})(UserMembershipRoleEnum = exports.UserMembershipRoleEnum || (exports.UserMembershipRoleEnum = {}));
exports["default"] = RoleEnum;
//# sourceMappingURL=role-enum.js.map